import React, { Component } from 'react';
import { connect } from 'react-redux';
import RunOffsDisplayImage from './../../components/RunOffsDisplayImage';
import ParkingSpotInfo from './ParkingSpotInfo';
import PointOfInterestInfo from './../../components/MapInfoBar/PointOfInterestInfo';
import {getDetailsForSpot} from './../../utils';

class MapInfoBar extends Component {

  render() {
    let { selectedSpot, selectedPointsOfInterest, isReadOnly } = this.props;

    if(selectedSpot) {
      const spotDetails = getDetailsForSpot(selectedSpot);
      return <ParkingSpotInfo spotId={selectedSpot} spotDetails={spotDetails} isReadOnly={isReadOnly} />;
    }

    if(selectedPointsOfInterest && selectedPointsOfInterest.location) {
      return <PointOfInterestInfo pointsOfInterest={selectedPointsOfInterest} />;
    }

    return <RunOffsDisplayImage />;
  }

}

const mapStateToProps = (state) => {
  const { selectedSpot, selectedPointsOfInterest, list:parkingSpotsList } = state.parkingSpots;
  return {
    selectedSpot,
    selectedPointsOfInterest,
    parkingSpotsList
  };
};

export default connect(mapStateToProps)(MapInfoBar);



// WEBPACK FOOTER //
// ./src/containers/MapInfoBar/index.js